import { ClienteVendaCompradorSecao } from '../../../../../../../types/cliente-venda';
import { CollapsibleSection } from '../../produtos/sections/collapsible-section';
import { Row } from './styles';

interface Props {
  data: ClienteVendaCompradorSecao;
}

const fullName = (data: ClienteVendaCompradorSecao): string =>
  `${data.nome ?? ''} ${data.sobrenome ?? ''}`.trim() || '—';

const enderecoLinha = (data: ClienteVendaCompradorSecao): string => {
  const e = data.endereco;
  const parts = [
    [e.address, e.numero].filter(Boolean).join(', '),
    e.complement,
    e.district,
    [e.city, e.state].filter(Boolean).join(' / '),
    e.postalCode,
  ].filter((p) => p && p.trim().length > 0);
  return parts.join(' · ');
};

export const CompradorSection = ({ data }: Props) => {
  const endereco = enderecoLinha(data);
  return (
    <CollapsibleSection
      title="Comprador"
      defaultOpen
      testId="venda-section-comprador"
    >
      <Row>
        <span>Nome</span>
        <span>{fullName(data)}</span>
      </Row>
      <Row>
        <span>E-mail</span>
        <span>{data.email ?? '—'}</span>
      </Row>
      <Row>
        <span>Telefone</span>
        <span>{data.telefone ?? '—'}</span>
      </Row>
      <Row>
        <span>CPF</span>
        <span>{data.cpf ?? '—'}</span>
      </Row>
      {endereco && (
        <Row>
          <span>Endereço</span>
          <span>{endereco}</span>
        </Row>
      )}
    </CollapsibleSection>
  );
};
